import { RootState } from '@/app/store';
import { camelizeNestedKeys, Market, Markets } from '@cex/shared-modules';
import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

const marketsAdapter = createEntityAdapter<Market>();
const initialState = marketsAdapter.getInitialState();

import { mainEmptySplitApi } from '@/features/main/mainApi';

export const marketsApi = mainEmptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMarkets: builder.query({
      query: () => '/markets',
      transformResponse: (responseData: Markets) => {
        return marketsAdapter.setAll(initialState, camelizeNestedKeys(responseData));
      }
    })
  })
});

// Selectors
// Calling `someEndpoint.select(someArg)` generates a new selector that will return
// the query result object for a query with those parameters.
// To generate a selector for a specific query argument, call `select(theQueryArg)`.
// In this case, the users query has no params, so we don't pass anything to select()
// @ts-ignore
export const selectMarketsResult = marketsApi.endpoints.getMarkets.select();

const selectMarketsData = createSelector(selectMarketsResult, (apiSlice) => apiSlice.data);

export const { selectAll: selectAllMarkets, selectById: selectMarketById } = marketsAdapter.getSelectors(
  (state: RootState) => selectMarketsData(state) ?? initialState
);

export const { useGetMarketsQuery } = marketsApi;
